import { BreadcrumbItem } from '@src/api/common/BreadcrumbTypes';
import { PageTitle } from '@src/api/common/PageTitleType';

const Breadcrumbs: Array<BreadcrumbItem> = [
  { title: 'Home', isLink: true, href: '/' },
  { title: 'Route Tool', isLink: false },
  { title: 'Search Records', isLink: false },
];

const Title: PageTitle = {
  title: '',
};

export { Breadcrumbs, Title };
